import React, {Component} from 'react';
import StatusBar from '../common/StatusBar'
import ActionButton from '../viewer/ActionButton'


class Submenu extends Component{
    constructor(props, context) {
        super(props, context);
        this.state = {
            activeSection: this.props.activeSection || null,
            activePanel: this.props.activePanel || null
        };
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props === prevProps){
            return false
        }
    }
    changeSection(e){
        let section = e.target ? e.target.id : e ;
        if(e.target){
            e.preventDefault();
        }
        this.props.changeSection(e)
    }
    openPanel(e){
        let section = e.target ? e.target.id : e ;
        if(e.target){
            e.preventDefault();
        }
        this.props.openPanel(e)
    }
    render(){
        const subMenuSection = [
            {title: "Datos del caso", id: "casodata", action: this.changeSection.bind(this), active: this.props.activeSection},
            {title: "Archivos adjuntos", id: "attachments", action: this.changeSection.bind(this), active: this.props.activeSection}
        ]
        if(this.props.isAdmin == 1){
            subMenuSection.push({title: "Modelos", id: "modelos", action: this.changeSection.bind(this), active: this.props.activeSection});
            subMenuSection.push({title: "Notas", id: "notes", action: this.changeSection.bind(this), active: this.props.activeSection});
        }
        if(this.props.caso.modelos && this.props.caso.modelos.length > 0){
            subMenuSection.push({title: "3D Checker", id: "viewport", icon: "text-muted fa fa-cube", action: this.changeSection.bind(this), active: this.props.activeSection})
        }
        const subMenuPanels = [
            {title: "Comentarios", id: "comments", icon: "text-muted fa fa-commenting-o", action: this.openPanel.bind(this), active: this.props.activePanel}
        ]
        if(this.props.caso.modelos && this.props.caso.modelos.length > 0){
            subMenuPanels.unshift({title: "IPR / Ataches", id: "info", icon: "text-muted fa fa-crosshairs", action: this.openPanel.bind(this), active: this.props.activePanel})
        }
        const navList = (items) => {
            return items.map( (item, index) => (
                <li key={index} className={index === 0 ? "nav-item active" : "nav-item"}>
                    <a
                        className={item.active === item.id ? "nav-link active " +item.id : "nav-link "+item.id}
                        key={index} id={item.id}
                        href="#"
                        onClick={item.action}
                    >
                        <i className={item.icon}></i>  &nbsp;{item.title}
                    </a>
                </li>
            ));
        };
        const showButton = (status) => {
            let active = false
            status = Number(status)
            if(this.props.isAdmin == 1){
                switch(Number(status)) {
                    case 0:
                        active = true
                        break
                    case 1:
                        active = true
                        break
                    case 2:
                        active = false
                        break
                    case 3:
                        active = true
                        break
                    case 4:
                        active = true
                    case 5:
                        active = true
                        break
                }
            }else{
                switch(status) {
                    case 0:
                        active = false
                        break
                    case 1:
                        active = false
                        break
                    case 2:
                        active = true
                        break
                    case 3:
                        active = false
                        break
                    case 4:
                        active = false
                        break
                    case 5:
                        active = false
                        break
                    case 6:
                        active = true
                        break
                }
            }
            return active
        }
        return(
            <nav className="row submenu">
                <div className="col-12">
                    <div className="row">
                        <div className={showButton(this.props.caso.status) ? "col-6 patient-name" : "col-9 patient-name"}>
                            <span className="text-muted small">
                                Paciente:
                            </span> {this.props.caso && this.props.caso.title}
                        </div>
                        <div className="col-md-3 status-top">
                            <StatusBar status={this.props.status} partialDelivery={this.props.caso.partial_delivery} />
                        </div>
                        <div className={showButton(this.props.caso.status) ? "col-md-3 action-button-top" : "hide"}>
                            <div className="action-button-container">
                                <ActionButton
                                    casoId={this.props.caso.id}
                                    updateCaso={this.props.updateCaso.bind(this)}
                                    isAdmin={this.props.isAdmin}
                                    status={this.props.status}
                                    partialDelivery={this.props.caso.partial_delivery}
                                    addComment={this.props.addComment.bind(this)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 sections-menu">
                    <div className="row">
                        <div className="col-md-8">
                            <ul className="nav nav-tabs">
                                {navList(subMenuSection)}
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <ul className="nav nav-tabs justify-content-end">
                                {navList(subMenuPanels)}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}
export default Submenu;


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/Submenu.jsx